import { connect } from 'react-redux';
import merge from 'deepmerge';
import View from './AdditionalSavingsView';
import { goalId as selectedGoalId } from '../../FinancialPlanGoalDropdown/FinancialPlanGoalDropdownSelector';
import RouteDictionary from '../WhatIfsRouteDictionary';
import {
  allocatedCashflowSelector,
  totalAllocatedCashflowOtherGoalsSelector,
  availableCashflowSelector,
  maxCashflowSelector,
  allocateExcessCashflowSelector,
  isSaveRemainingCashflowHandlingModeSelector,
} from './AdditionalSavingsSelector';
import { goalsAdditionalSavingsWhatIfsOrDefaultSelector } from '../CompareGoals/CompareGoalsSelector';
import { applyAdditionalSavingsIfDirty } from '../CompareGoals/CompareGoalsActions';
import {
  updateWhatIfsData,
  applyWhatIf,
  fetchWhatIfOptions,
  planImpact,
  initialPlanImpact,
  setCompareGoalsOpen,
  updateCompareGoalsData,
} from '../WhatIfsActions';
import {
  loading,
  nullableFpIdSelector,
  areOptionsLoaded,
  whatIfInnerSelector,
  whatIfTemplateInnerSelector,
  impactSelector,
  nullableTitleSelector,
  nullableGroupTitleSelector,
  compareGoalsOpenSelector,
  isOPLMonteCarloSelector,
} from '../WhatIfsSelector';

const mapStateToProps = (state, ownProps) => ({
  fpId: nullableFpIdSelector(state, ownProps),
  goalId: selectedGoalId(state, ownProps),
  areOptionsLoaded: areOptionsLoaded(state, ownProps),
  whatIf: whatIfInnerSelector(state, ownProps),
  whatIfTemplate: whatIfTemplateInnerSelector(state, ownProps),
  loading: loading(state, ownProps),
  title: nullableTitleSelector(state, ownProps),
  groupTitle: nullableGroupTitleSelector(state, ownProps),
  planImpactItems: impactSelector(state, ownProps),
  allocatedCashflow: allocatedCashflowSelector(state, ownProps),
  totalAllocatedCashflowOtherGoals: totalAllocatedCashflowOtherGoalsSelector(state, ownProps),
  availableCashflow: availableCashflowSelector(state, ownProps),
  maxCashflow: maxCashflowSelector(state, ownProps),
  compareGoalsOpen: compareGoalsOpenSelector(state, ownProps),
  allocateExcessCashflow: allocateExcessCashflowSelector(state, ownProps),
  goalsAdditionalSavingsWhatIfs: goalsAdditionalSavingsWhatIfsOrDefaultSelector(state, ownProps),
  isSaveRemainingCashflowHandlingMode: isSaveRemainingCashflowHandlingModeSelector(state, ownProps),
  isOPLMonteCarlo: isOPLMonteCarloSelector(state),
});

const mapDispatchToProps = dispatch => ({
  compareGoalsClicked: clientId => () => {
    dispatch(setCompareGoalsOpen(clientId, true));
  },
  storeData: (goalId, fpId, whatIf, whatIfTemplate, whatIfType) => (data, clientId) => {
    dispatch(updateWhatIfsData(clientId, goalId, whatIfType, data));
    dispatch(
      planImpact(
        clientId,
        fpId,
        goalId,
        merge(whatIf, data.WhatIf, { arrayMerge: (a, b) => b }),
        RouteDictionary[whatIfTemplate.WhatIfType],
        Object.keys(whatIfTemplate),
        whatIfTemplate.WhatIfType,
      ),
    );
  },
  clearCompareGoalsData: clientId => {
    dispatch(updateCompareGoalsData(null, null, clientId));
  },
  fetchPlanImpact: (clientId, fpId, goalId, whatIf, whatIfTemplate) => {
    dispatch(
      planImpact(
        clientId,
        fpId,
        goalId,
        whatIf,
        RouteDictionary[whatIfTemplate.WhatIfType],
        Object.keys(whatIfTemplate),
        whatIfTemplate.WhatIfType,
      ),
    );
  },
  fetchInitialPlanImpact: (clientId, fpId, goalId, whatIf, whatIfTemplate) => {
    dispatch(
      initialPlanImpact(
        clientId,
        fpId,
        goalId,
        whatIf,
        RouteDictionary[whatIfTemplate.WhatIfType],
        Object.keys(whatIfTemplate),
        whatIfTemplate.WhatIfType,
      ),
    );
  },
  fetchData: (clientId, fpId, goalId, whatIfType) => {
    dispatch(fetchWhatIfOptions(clientId, fpId, goalId, RouteDictionary[whatIfType], whatIfType));
  },
  applyWhatIf: (clientId, fpId, goalId, whatIf, whatIfTemplate, whatIfs) => () => {
    dispatch(
      applyWhatIf(
        clientId,
        fpId,
        goalId,
        whatIf,
        RouteDictionary[whatIfTemplate.WhatIfType],
        Object.keys(whatIfTemplate),
        whatIfTemplate.WhatIfType,
      ),
    );
    dispatch(applyAdditionalSavingsIfDirty(clientId, fpId, whatIfs));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(View);
